import React, { Fragment } from "react";
import { Card, Col, Button } from 'react-bootstrap';
import '../../../../styles/leis-auth.scss'
import Moment from 'moment';

const Lei = (props) => {
    const dataLei = Moment(props.lei.data_lei).utc(false).format("DD [de] MMMM [de] YYYY")
    const url = `/transparencia${props.lei.link_lei}`
    return (
        <Fragment>
            <Col>
                <Card className="card-list">
                <Card.Header><h5>{props.lei.categoria} N° {props.lei.num_lei} de {dataLei}</h5></Card.Header>
                    <Card.Body>
                        <Card.Text>
                            <p>{props.lei.ementa}</p>
                        </Card.Text>
                        <a href={url} target="_blank" rel="noreferrer">
                            <Button type="button" variant="primary">Ver Lei</Button>
                        </a>
                    </Card.Body>
                </Card>
            </Col>
        </Fragment >)
}

export default Lei;